<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbar_timeout"
      :color="snackbar_color"
      :top="true" >
      {{ snackbar_message }}
    </v-snackbar>

    <v-card flat class="mt-5" >
      <v-card-title>
        <h6 class="primary--text">Liste des roles</h6>
        <v-spacer></v-spacer>
            <v-btn
                rounded
                color="primary"
                dark class="mb-2"
                to="roles/new"
                v-if="$can('create roles')">
                    Ajouter
              <v-icon right>mdi-plus-circle-outline</v-icon>
            </v-btn>

        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher un rôle"
          single-line
          solo
          hide-details>
        </v-text-field>

      </v-card-title>
    </v-card>

  <v-data-table
    :headers="headers"
    :items="liste_roles"
    :loading="loading"
    loading-text="Loading..."
    sort-by="name"
    :search="search"
    class="elevation-1">

    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
        v-if="$can('edit roles')">
        mdi-pencil-outline
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
        v-if="$can('delete roles')">
        mdi-trash-can-outline
      </v-icon>
    </template>
  </v-data-table>

  <v-layout row justify-center>
    <v-dialog
      v-model="dialog_deletion"
      max-width="290">
      <v-card>
        <v-card-title class="headline">Suppression</v-card-title>
        <v-card-text class="text-center">
         Etes-vous sûr de vouloir supprimer ce rôle ?
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="orange"
            rounded
            @click="dialog_deletion = false">
             <span class="white-couleur">Non</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            rounded :loading="load" :disabled="load"
            @click="delRole()">
            Oui
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  </div>
</template>

<script>
import Permissions from '~/mixins/Permissions';

export default {
  name: 'settings-roles',
  mixins: [Permissions],
  data: () => ({
    del_role: null,
    del_index: null,
    roleId: null,
    search: '',
    loading: false,
    load: false,
    dialog_edit: false,
    dialog_deletion: false,
    headers: [
          { text: 'Nom', value: 'name' },
          { text: 'Description', value: 'description' },
          { text: 'Actions', value: 'action', sortable: false }
        ],
    roles_fields : {
          "Nom": "name",
          "Description": "description",
      },
    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    snackbar_color: '',

    editedIndex: -1,
    editedItem: {
      name: '',
      description: '',
      guard_name: '',
    },
    defaultItem: {
      name: '',
      description: '',
      guard_name: '',
    },

  }),

  created () {
    this.loading = true
    this.fetchUtils();
    this.loading = false
  },

  computed: {
    liste_roles () { return this.$store.getters.getRoles; },
  },

  watch: {
      dialog (val) {
        val || this.close()
      },
    },

  methods: {
    fetchUtils () {
      this.$store.dispatch("loadRoles");
    },

    editItem (item) {
        this.$router.push({ name: 'roles.edit', params: { roleId: item.id }})
    },

    deleteItem (item) {
      this.del_index = this.liste_roles.indexOf(item);
      this.dialog_deletion = true;
      this.del_role = this.del_index;
      this.roleId = item.id;
    },

    close () {
      this.dialog_edit = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async delRole() {
      this.load = true;
      await this.$store.dispatch("deleteRole", this.roleId);
      this.fetchUtils();
      this.dialog_deletion = false;
      this.snackbar = true;
      this.snackbar_color = 'success';
      this.snackbar_message = "Role supprimé avec succès !";
      this.load = false;
    },

  }
};
</script>

<style scoped>
.white-couleur{
  color: white;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/settings/roles/index.vue